import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import moment from 'moment';
import { ThreeCircles } from 'react-loader-spinner';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import { event, $ } from "jquery";
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"

const TOP_KPIS_SECOND_PAGE_MAIN = {
  discharge_cycle: 0,
  distance_travelled: 0,
  distance_travelled_start: 0,
  distance_travelled_end: 0,
  per_idel_time: 0,
  avg_discharge_cycle: 0,
  mean_range: 0,
  mean_whr: 0,
  avg_cusumption_cycle: 0,
};


function TopkpisSecondMain_Orion({ gloablfilter, apiend }) {
  const [topdata, setTopData] = useState(TOP_KPIS_SECOND_PAGE_MAIN);
  const [modaldata, setModaldata] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [total_km_value, setCommas] = useState();
  const [distance_travelled_start, setStartdate] = useState();
  const [distance_travelled_end, setEnddate] = useState();
  const [currentRadioValue, setCurrentRadioValue] = useState("optioncharging")

  const appyData = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        // discharge_cycle: temp_result.doc_count,
        discharge_cycle: temp_result.vehicleId.doc_count,
        distance_travelled: temp_result.Distance_Travelled.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        distance_travelled_start: ((temp_result.min_Start_odo.value) != null) ? (temp_result.min_Start_odo.value) : 0,
        distance_travelled_end: ((temp_result.max_End_odo.value) != null) ? (temp_result.max_End_odo.value) : 0,
        // per_idel_time: (temp_result.median_Discharge.values["50.0"] != null && temp_result.median_Discharge.values["50.0"] != 0) ? ((temp_result.median_Discharge.values["50.0"]) / 3600).toFixed(2) : 0,
        per_idel_time: (temp_result.median_Discharge.values["50.0"] != null && temp_result.median_Discharge.values["50.0"] != 0) ? ((temp_result.median_Discharge.values["50.0"])).toFixed(2) : 0,
        avg_discharge_cycle: (temp_result.median_Percentage_Idle_Time.values["50.0"] != null) ? (temp_result.median_Percentage_Idle_Time.values["50.0"]).toFixed(2) : 0,
        mean_range: (temp_result.median_Range.values["50.0"] != null) ? (temp_result.median_Range.values["50.0"]).toFixed(2) : 0,
        mean_whr: (temp_result.median_kwh_km.values["50.0"] != null) ? (temp_result.median_kwh_km.values["50.0"]).toFixed(2) : 0,
        avg_cusumption_cycle: (temp_result.median_NetkWh.values["50.0"] != null) ? (temp_result.median_NetkWh.values["50.0"]).toFixed(2) : 0
      }
      setTopData((prestate) => responce);
    }
    else {
      setTopData((prestate) => TOP_KPIS_SECOND_PAGE_MAIN);
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)

  const appyDataModal = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      setModaldata(temp_result);
    } else {
      setModaldata([]);
    }
  }

  const loadModalData = () => {
    setCurrentRadioValue("optioncharging")
    fetchData({ url: API_URL_MAIN + "orion_drive_api/dischargecycle_orion", body: { filterdata: gloablfilter } }, appyDataModal)
  }
  const handleRadioChange = (e) => {
    setCurrentRadioValue(e.target.value);
  };
  const handlePlatformChange = (event) => {
    const toggel = event.target.value
    if (toggel === "optioncharging")
      fetchData({ url: API_URL_MAIN + "orion_drive_api/dischargecycle_orion", body: { filterdata: gloablfilter } }, appyDataModal)
    else
      fetchData({ url: API_URL_MAIN + "orion_drive_api/outliers_orion", body: { filterdata: gloablfilter } }, appyDataModal)
  }
  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input_bus" type="radio" name="inlineRadioOptionsCharging" id="inlineRadio1" value="optioncharging" checked={currentRadioValue === 'optioncharging'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                    <label className="form-check-label" htmlFor="inlineRadio1">&nbsp; Discharge Cycles</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input_bus" type="radio" name="inlineRadioOptionsOutlires" id="inlineRadio2" value="optionoutliers" checked={currentRadioValue === 'optionoutliers'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                    <label className="form-check-label" htmlFor="inlineRadio2">&nbsp; Outliers</label>
                  </div>
                </div>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "1500px" }}>
                  <thead style={{ backgroundColor: '#83A4CF', color: '#fff', position: "sticky", top: 0, zIndex: 0 }}>
                    <tr>
                      <th scope="col">Cycle</th>
                      <th scope="col">Start Time</th>
                      <th scope="col">End Time</th>
                      <th scope="col">totalTimeInSec</th>
                      <th scope="col">Soc Start</th>
                      <th scope="col">Soc End</th>
                      <th scope="col">Discharge</th>
                      <th scope="col">ODO Start</th>
                      <th scope="col">ODO End</th>
                      <th scope="col">Distance Travelled (Km)</th>
                      <th scope="col">Delta DTE (km)</th>
                      <th scope="col">Error DTE</th>
                      <th scope="col">Range</th>
                      <th scope="col">A_KWh_start</th>
                      {/* <th scope="col">B_KWh_start</th>
                      <th scope="col">C_KWh_start</th>
                      <th scope="col">D_KWh_start</th> */}
                      <th scope="col">A_KWh_end</th>
                      {/* <th scope="col">B_KWh_end</th>
                      <th scope="col">C_KWh_end</th>
                      <th scope="col">D_KWh_end</th> */}
                      <th scope="col">NetkWh</th>
                      <th scope="col">kwh/km</th>
                      <th scope="col">VCU_BMS_No</th>
                      {/* <th scope="col">LOB</th>
                      <th scope="col">PL</th>
                      <th scope="col">PPL</th>
                      <th scope="col">DLR_ORG_CITY</th> */}
                      <th scope="col">eventdate</th>
                    </tr>
                  </thead>
                  <tbody>

                    {isLoading ? loader : (modaldata.length == 0) ? <tr><td colSpan='17' className="alert alert-danger no_data" style={{ background: "#f4c2ce" }}>No records found</td></tr> : modaldata.map((x, index) => {
                      return (<tr key={index}>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{index + 1}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{moment(new Date(x._source.Start_Time)).format("YYYY-MM-DD HH:mm:ss")}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{moment(new Date(x._source.End_Time)).format("YYYY-MM-DD HH:mm:ss")}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.totalTimeInSec}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Soc_Start}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Soc_End}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Discharge}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Start_odo}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.End_odo}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Distance_Travelled}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Delta_DTE}</td>
                        {/* <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.Error_DTE)) ? "null" : parseFloat(x._source.Error_DTE.toFixed(2))}</td> */}
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.Error_DTE}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.Range)) ? "null" : parseFloat(x._source.Range.toFixed(2))}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.A_KWh_Start}</td>
                        {/* <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.B_KWh_Remain_start}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.C_KWh_Remain_start}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.D_KWh_Remain_start}</td> */}
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.A_KWh_End}</td>
                        {/* <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.B_KWh_Remain_End}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.C_KWh_Remain_End}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.D_KWh_Remain_End}</td> */}
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.NetkWh)) ? "null" : parseFloat(x._source.NetkWh.toFixed(2))}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.whPerKM)) ? "null" : parseFloat(x._source.whPerKM.toFixed(2))}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.VCU_BMS_No}</td>
                        {/* <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.LOB}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.PL}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.PPL}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.DLR_ORG_CITY}</td> */}
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.eventdate}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="kpi my-3">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-12 col-lg-8 pl-0">
            <div className="row">
              <div className="col-md-3 col-sm-6 col-6 pl-0 bus_tkps">
                <div className="widget_bus widget_Bus p-2 py-3 d-flex align-items-center" style={{ minHeight: "110px" }}>
                  <div className="widgetIcon">
                    <img src="../../../assets/img_orion/DA2_KPI_img1.png" />{" "}
                  </div>
                  {
                    loggedInUser.flagForHideShow === "ERC" ?
                      <div className="pl-3" data-bs-toggle="modal" data-bs-target="#staticBackdrop" style={{ cursor: "pointer" }} onClick={loadModalData} >
                        <div className="ps-3">
                          <p className="h5 m-0 font-bus-head">{isLoading ? loader : (topdata.discharge_cycle)}</p>
                          <p className="m-0">
                            <small className="">Discharge Cycle(s)</small>
                          </p>
                        </div>
                      </div>
                      :
                      <div className="pl-3">
                        <div className="ps-3">
                          <p className="h5 m-0 font-bus-head">{isLoading ? loader : (topdata.discharge_cycle)}</p>
                          <p className="m-0">
                            <small className="">Discharge Cycle(s)</small>
                          </p>
                        </div>
                      </div>
                  }
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-6 pl-0 bus_tkps">
                <div className="widget_bus widget_Bus p-2 py-3 d-flex align-items-center" style={{ minHeight: "110px" }}>
                  <div className="widgetIcon">
                    <img src="../../../assets/img_orion/DA2_KPI_img2.png" />{" "}
                  </div>
                  <div className="pl-1" style={{ width: '74%', display: 'inline-block' }}>
                    <div>
                      <div className="fst" style={{ borderBottom: 'none', marginRight: "1px", float: 'right', fontSize: "10px" }}>
                        <b style={{ borderBottom: 'solid 2px #ffa650' }} className="charging_cy" id="charging_cy_fast">{topdata.distance_travelled_start}</b> Start
                      </div>
                      <div className="sl" style={{ borderBottom: 'none', fontSize: "10px" }}>
                        <b style={{ borderBottom: 'solid 2px #1494ac' }} className="charging_cy" id="charging_cy_slow">{topdata.distance_travelled_end}</b> End
                      </div>
                      <p className="h5 mt-2 mb-0 font-bus-head">{isLoading ? loader : (topdata.distance_travelled)}km</p>
                      <p className="m-0">
                        <small className="">Distance Travelled</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-6 pl-0 bus_tkps">
                <div className="widget_bus widget_Bus p-2 py-3 d-flex align-items-center" style={{ minHeight: "110px" }}>
                  <div className="widgetIcon">
                    {/* <img src="../../../assets/img_orion/DA2_KPI_img3.png" />{" "} */}
                    <img src="../../../assets/img_orion/orion_battery.png" />{" "}
                  </div>
                  <div className="ps-3">
                    <p className="h5 m-0 font-bus-head">{isLoading ? loader : (topdata.per_idel_time)} %</p>
                    <p className="m-0">
                      {/* <small className="">Median discharge duration/cycle</small> */}
                      <small className="">Average discharge/Cycle (%SoC)</small>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-6 pl-0 bus_tkps">
                <div className="widget_bus widget_Bus p-2 py-3 d-flex align-items-center" style={{ minHeight: "110px" }}>
                  <div className="widgetIcon">
                    {/* <img src="../../../assets/img_orion/DA2_KPI_img4.png" />{" "} */}
                    <img src="../../../assets/img_orion/orion_vehicle.png" />{" "}
                  </div>
                  <div className="ps-1">
                    <p className="h5 m-0 font-bus-head">{isLoading ? loader : (topdata.avg_discharge_cycle)} %</p>
                    <p className="m-0">
                      {/* <small className=""> Avg Discharge/Cycle</small> */}
                      <small className="">Median Percentage Idle Time</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-12 col-lg-4 pl-0 bus_tkps">
            <div className="widget_bus widget_Bus mt-0" style={{ padding: "10px 0",minHeight: "110px"   }}>
              <div className="row">
                <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-4 bt-graph pr-0' : 'col-lg-6 col-md-4 col-sm-4 bt-graph pr-0')}>
                  <div className="text-center">
                    <div className="widgetIcon-32">
                      {/* <img src="../../../assets/img_orion/electric-bus (2).png" />{" "} */}
                      <img src="../../../assets/img_orion/orion_location.png" />{" "}
                    </div>
                    <div className="mt-1">
                      <p className="h5 m-0 font-bus-head">{isLoading ? loader : (topdata.mean_range)}km</p>
                      <p className="m-0">
                        {/* <small className="">Median Range (for 80% discharge)</small> */}
                        <small className="">Median Range</small>
                      </p>
                    </div>
                  </div>
                </div>
                <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-4 bt-graph' : 'col-lg-6 col-md-4 col-sm-4 bt-graph')}>
                  <div className="text-center">
                    <div className="widgetIcon-32">
                      <img src="../../../assets/img_orion/DA2_KPI_img6.png" />{" "}
                    </div>
                    <div className="mt-1">
                      <p className="h5 m-0 font-bus-head">{isLoading ? loader : (topdata.mean_whr)}</p>
                      <p className="m-0">
                        <small className="">Median kWh/km</small>
                      </p>
                    </div>
                  </div>
                </div>
                {

                  loggedInUser.flagForHideShow === "ERC" &&
                  <div className="col-lg-4 col-md-4 col-sm-4 bt-graph pl-0">
                    <div className="text-center" style={{ marginLeft: 0 }}>
                      <div className="widgetIcon-32">
                        <img src="../../../assets/img_orion/DA2_KPI_img7.png" />{" "}
                      </div>
                      <div className="mt-1">
                        <p className="h5 m-0 font-bus-head">{isLoading ? loader : (topdata.avg_cusumption_cycle)} kWh</p>
                        <p className="m-0">
                          <small className="">Median Net Consumption/cycle</small>
                        </p>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default TopkpisSecondMain_Orion;
